import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusCircle = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		opacity: .4,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			rx: 14,
			fill: "white"
		}), /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 27,
			height: 27,
			rx: 13.5,
			stroke: "currentColor",
			strokeOpacity: .5,
			strokeDasharray: "2 2"
		})]
	}), /* @__PURE__ */ _jsxs("g", {
		opacity: .6,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M13 6H15V22H13V6Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M6 13H22V15H6V13Z",
			fill: "currentColor"
		})]
	})]
});
const ForwardRef = forwardRef(SvgPlusCircle);
export { ForwardRef as ReactComponent };
